import { Button, Alert } from "react-bootstrap";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Popup from "../../common/modal/Popup";
import Loader from "../../common/loader/Loader";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import { toggleIMCTimeActivation } from "../../../store/actions/imcAction";
const ToggelActivatatePopup = ({
  toggleActivateRec,
  toggleActivateStatus,
  onHide,
  toggleActivateModalShow,
  setToggleActivateModalShow,
}) => {
   const [isAction, setIsAction] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const dispatch = useDispatch();
  const { error: apiError, isLoader } = useSelector((state) => state.imcs);

  const submitHandler = () => {
     setIsAction(true);
    return dispatch(
      toggleIMCTimeActivation({
        timeId: toggleActivateRec,
        isActive: toggleActivateStatus ? "false" : "true",
      })
    ).then(() => {
      setIsDone(true);
      onHide();
      setToggleActivateModalShow(false);
    });
  };

  const hideHandlerRes = () => {
    setIsAction(false);
    setIsDone(false);
  };

  return (
    <>
      <Popup
        onHide={() => onHide()}
        size="md"
        show={toggleActivateModalShow}
        title={
          toggleActivateStatus
            ? "Deactivate IMC/STROKE Auto Report"
            : "Activate IMC/STROKE Auto Report"
        }
        footer={
          <>
          {apiError ? (
            <>
             <Button
             variant="outline-secondary model-btn"
             className="me-4"
             onClick={(e) => onHide()}
           >
             Ok
           </Button>
           </>
          ):(
            <>
            <Button
              variant="outline-secondary model-btn"
              className="me-4"
              onClick={(e) => onHide()}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler()}
            >
              Confirm
            </Button>
            </>
          )}
            
          </>
        }
      >
        {isLoader && <Loader />}
        {apiError && (
          <Alert variant={"danger"}>
            {apiError?.message || "Access denied! Please try again"}
          </Alert>
        )}
        <div style={{ textAlign: "center" }}>
        {apiError ? <></>:<>
        {toggleActivateStatus
            ? "Are you sure you want to deactivate this IMC/STROKE auto report?"
            : "Are you sure you want to activate this IMC/STROKE auto report?"}
        </>}
          
        </div>
      </Popup>
      {isAction && (
        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordUpdated: isDone,
            title: toggleActivateStatus ? "Deactivate IMC/STROKE Auto Report" : "Activate IMC/STROKE Auto Report",
            successMsg: toggleActivateStatus
              ? "Auto report for IMC/Stroke DEACTIVATED successfully!"
              : "Auto report for IMC/Stroke ACTIVATED successfully!",
          }}
        />
      )}
    </>
  );
};

export default ToggelActivatatePopup;
